import axios from './config/axios'

const postValidateAddress = (address) => {
  return axios.post('/api/forms/validate-address', address).then(r => r.data)
}
export default postValidateAddress